<script>
  import LineBarMixedChartTwoYAxis from "./LineBarMixedChartTwoYAxis.svelte";
  import { get_labels, transform_month_data } from "./SixModulesUtils.svelte";
  import DonutOrPolarCustom from "./DonutOrPolarCustom.svelte";
  import { nFormatter_org, object_values, percentage_math } from "./Utils.svelte";
  import { dict_to_sum } from "./UtilsBalkenProgress.svelte";

  export let chart_hoehe_2;

  export let redraw;
  export let year = 2090;
  export let include_vorjahr;

  export let target_lead = 10000;
  export let target_opp = 10000;
  export let target_cust = 10000;
  export let target_boli = 10000;

  export let current_target_lead = 10000;
  export let current_target_opp = 10000;
  export let current_target_cust = 10000;
  export let current_target_boli = 10000;

  let day_of_year = 1;

  let color_list = ["#51c3f9", "#37a76f", "#44c1a3", "#63a537"];

  let donut_data = {
    datasets: [
      {
        data: [50, 50],
        backgroundColor: [color_list[0], "#f2f2f2"],
        cutout: 10,
        weight: 0.3,
      },
      {
        data: [70, 30],
        backgroundColor: [color_list[1], "#f2f2f2"],
        cutout: 10,
        weight: 0.3,
      },
      {
        data: [30, 70],
        backgroundColor: [color_list[2], "#f2f2f2"],
        cutout: 10,
        weight: 0.3,
      },
      {
        data: [30, 70],
        backgroundColor: [color_list[3], "#f2f2f2"],
        cutout: 10,
        weight: 0.3,
      },
    ],
    labels: ["Unq", "Psq", "Mql", "Opp"],
  };

  export let leads_month_data_last_year = {
    "2020-01": 207,
    "2020-02": 356,
    "2020-03": 40,
    "2020-04": 540,
    "2020-05": 70,
    "2020-06": 475,
    "2020-07": 540,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let leads_month_data = {
    "2020-01": 520,
    "2020-02": 435,
    "2020-03": 40,
    "2020-04": 50,
    "2020-05": 750,
    "2020-06": 755,
    "2020-07": 40,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let opp_month_data_last_year = {
    "2020-01": 520,
    "2020-02": 35,
    "2020-03": 450,
    "2020-04": 50,
    "2020-05": 750,
    "2020-06": 75,
    "2020-07": 540,
    "2020-08": 510,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let opp_month_data = {
    "2020-01": 20,
    "2020-02": 35,
    "2020-03": 540,
    "2020-04": 550,
    "2020-05": 70,
    "2020-06": 575,
    "2020-07": 40,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let cust_month_data_last_year = {
    "2020-01": 120,
    "2020-02": 315,
    "2020-03": 40,
    "2020-04": 50,
    "2020-05": 370,
    "2020-06": 75,
    "2020-07": 40,
    "2020-08": 210,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let cust_month_data = {
    "2020-01": 20,
    "2020-02": 315,
    "2020-03": 40,
    "2020-04": 50,
    "2020-05": 170,
    "2020-06": 175,
    "2020-07": 40,
    "2020-08": 110,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let boli_month_data_last_year = {
    "2020-01": 210,
    "2020-02": 351,
    "2020-03": 410,
    "2020-04": 510,
    "2020-05": 70,
    "2020-06": 75,
    "2020-07": 40,
    "2020-08": 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };
  export let boli_month_data = {
    "2020-01": 20,
    "2020-02": 35,
    "2020-03": 410,
    "2020-04": 150,
    "2020-05": 710,
    "2020-06": 715,
    "2020-07": 40,
    "2020-08": 110,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let time_modus = "monthly";

  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [0, 0, 0, 0],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
    ],
  };

  $: {
    leads_month_data_last_year,
      leads_month_data,
      opp_month_data_last_year,
      opp_month_data,
      cust_month_data_last_year,
      cust_month_data,
      boli_month_data_last_year,
      boli_month_data,
      time_modus,
      include_vorjahr;
    if (
      leads_month_data_last_year &&
      leads_month_data &&
      opp_month_data_last_year &&
      opp_month_data &&
      cust_month_data_last_year &&
      cust_month_data &&
      boli_month_data_last_year &&
      boli_month_data &&
      time_modus
    ) {
      data = {
        labels: get_labels(year, time_modus),
        datasets: [
          include_vorjahr
            ? {
                label: "New LEADS previous year",
                data: transform_month_data(object_values(leads_month_data_last_year), time_modus),
                type: "bar",
                borderColor: "#D9D9D9",
                pointRadius: 0,
                yAxisID: "y",
              }
            : {},
          {
            label: "New LEADS",
            data: transform_month_data(object_values(leads_month_data), time_modus),
            type: "bar",
            borderColor: "#51c3f9",
            pointRadius: 0,
            yAxisID: "y",
          },
          include_vorjahr
            ? {
                label: "New OPP previous year",
                data: transform_month_data(object_values(opp_month_data_last_year), time_modus),
                type: "bar",
                borderColor: "#D9D9D9",
                pointRadius: 0,
                yAxisID: "y",
              }
            : {},
          {
            label: "New OPP",
            data: transform_month_data(object_values(opp_month_data), time_modus),
            type: "bar",
            borderColor: "#44c1a3",
            pointRadius: 0,
            yAxisID: "y",
          },
          include_vorjahr
            ? {
                label: "New CUST previous year",
                data: transform_month_data(object_values(cust_month_data_last_year), time_modus),
                type: "bar",
                borderColor: "#D9D9D9",
                pointRadius: 0,
                yAxisID: "y",
              }
            : {},
          {
            label: "New CUST",
            data: transform_month_data(object_values(cust_month_data), time_modus),
            type: "bar",
            borderColor: "#37a76f",
            pointRadius: 0,
            yAxisID: "y",
          },
          include_vorjahr
            ? {
                label: "Sold BOLUSES previous year",
                data: transform_month_data(object_values(boli_month_data_last_year), time_modus),
                type: "bar",
                borderColor: "#D9D9D9",
                pointRadius: 0,
                yAxisID: "y1",
              }
            : {},
          {
            label: "Sold BOLUSES",
            data: transform_month_data(object_values(boli_month_data), time_modus),
            type: "bar",
            borderColor: "#63a537",
            pointRadius: 0,
            yAxisID: "y1",
          },
        ],
      };

      // //Targets:
      // current_target_leads = get_last_available_value_target(object_values(leads_month_data), create_target_line(time_modus, leads_month_data, target_leads_start, target_lead))
      // current_target_opp = get_last_available_value_target(object_values(opp_month_data), create_target_line(time_modus, opp_month_data, target_opp_start, target_opp))
      // current_target_cust = get_last_available_value_target(object_values(cust_month_data), create_target_line(time_modus, cust_month_data, target_cust_start, target_cust))
      // current_target_boli = get_last_available_value_target(object_values(boli_month_data), create_target_line(time_modus, boli_month_data, target_boli_start, target_boli))

      let now = new Date();
      let start = new Date(now.getFullYear(), 0, 0);
      let diff = now - start;
      let oneDay = 1000 * 60 * 60 * 24;
      day_of_year = Math.floor(diff / oneDay);

      // Donut:

      let donut_percentage_1_vor;
      let donut_percentage_2_vor;
      let donut_percentage_3_vor;
      let donut_percentage_4_vor;

      if (year != new Date().getFullYear()) {
        donut_percentage_1_vor = percentage_math(dict_to_sum(leads_month_data), target_lead);
        donut_percentage_2_vor = percentage_math(dict_to_sum(opp_month_data), target_opp);
        donut_percentage_3_vor = percentage_math(dict_to_sum(cust_month_data), target_cust);
        donut_percentage_4_vor = percentage_math(dict_to_sum(boli_month_data), target_boli);
      } else {
        donut_percentage_1_vor = percentage_math(dict_to_sum(leads_month_data), current_target_lead);
        donut_percentage_2_vor = percentage_math(dict_to_sum(opp_month_data), current_target_opp);
        donut_percentage_3_vor = percentage_math(dict_to_sum(cust_month_data), current_target_cust);
        donut_percentage_4_vor = percentage_math(dict_to_sum(boli_month_data), current_target_boli);
      }

      let donut_percentage_1 = donut_percentage_1_vor > 100 ? 100 : donut_percentage_1_vor;
      let donut_percentage_2 = donut_percentage_2_vor > 100 ? 100 : donut_percentage_2_vor;
      let donut_percentage_3 = donut_percentage_3_vor > 100 ? 100 : donut_percentage_3_vor;
      let donut_percentage_4 = donut_percentage_4_vor > 100 ? 100 : donut_percentage_4_vor;

      let donut_percentage_1_rest = donut_percentage_1 >= 100 ? 0 : 100 - donut_percentage_1;
      let donut_percentage_2_rest = donut_percentage_2 >= 100 ? 0 : 100 - donut_percentage_2;
      let donut_percentage_3_rest = donut_percentage_3 >= 100 ? 0 : 100 - donut_percentage_3;
      let donut_percentage_4_rest = donut_percentage_4 >= 100 ? 0 : 100 - donut_percentage_4;

      console.log("MANAGEMENT leads_month_data: ", leads_month_data);

      donut_data = {
        datasets: [
          {
            data: [donut_percentage_1, donut_percentage_1_rest],
            backgroundColor: [color_list[0], "#f2f2f2"],
            cutout: 10,
            weight: 0.3,
          },
          {
            data: [donut_percentage_2, donut_percentage_2_rest],
            backgroundColor: [color_list[1], "#f2f2f2"],
            cutout: 10,
            weight: 0.3,
          },
          {
            data: [donut_percentage_3, donut_percentage_3_rest],
            backgroundColor: [color_list[2], "#f2f2f2"],
            cutout: 10,
            weight: 0.3,
          },
          {
            data: [donut_percentage_4, donut_percentage_4_rest],
            backgroundColor: [color_list[3], "#f2f2f2"],
            cutout: 10,
            weight: 0.3,
          },
        ],
        labels: ["Unq", "Psq", "Mql", "Opp"],
      };

      redraw = false;
      redraw = true;
    }
  }

  function replace_dot(number) {
    var s = number.toString();
    s = s.replace(".", ",");
    return s;
  }
</script>

<div class="row">
  <div class="col" style="padding-right: 6px;">
    <div class="row" style="background-color: #f2f2f2; height: 120px; margin: 0px;">
      <div class="col-12" style="margin: auto;">
        <DonutOrPolarCustom data={donut_data} tooltip={false} />
      </div>
    </div>
  </div>
  <div class="col" style="padding-left: 6px; ">
    <div class="row" style="background-color: #f2f2f2; height: 120px; margin: 0px;">
      <!-- <div class="col-2" /> -->
      <div class="col-12" style="display: flex; align-items: center;">
        <div class="row" style="margin:auto;">
          <div class="col">
            <div class="row">
              <div
                class="small-rect-2"
                style="background-color:{color_list[0]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
              />
              New LEADS&nbsp;&nbsp;

              <div
                class={dict_to_sum(leads_month_data) >= (year != new Date().getFullYear() ? target_lead : current_target_lead)
                  ? "dot-innen-gruen"
                  : "dot-innen-orange"}
              />
            </div>
            <div class="row">
              <div
                class="small-rect-2"
                style="background-color: {color_list[1]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
              />
              New OPP&nbsp;&nbsp;
              <div
                class={dict_to_sum(opp_month_data) >= (year != new Date().getFullYear() ? target_opp : current_target_opp)
                  ? "dot-innen-gruen"
                  : "dot-innen-orange"}
              />
            </div>
            <div class="row">
              <div
                class="small-rect-2"
                style="background-color: {color_list[2]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
              />
              New CUST&nbsp;&nbsp;
              <div
                class={dict_to_sum(cust_month_data) >= (year != new Date().getFullYear() ? target_cust : current_target_cust)
                  ? "dot-innen-gruen"
                  : "dot-innen-orange"}
              />
            </div>
            <div class="row">
              <div
                class="small-rect-2"
                style="background-color: {color_list[3]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
              />
              Sold BOLUSES&nbsp;&nbsp;
              <div
                class={dict_to_sum(boli_month_data) >= (year != new Date().getFullYear() ? target_boli : current_target_boli)
                  ? "dot-innen-gruen"
                  : "dot-innen-orange"}
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-2" /> -->
    </div>
  </div>
</div>

<div class="row" style="width:100%; margin: 0px; height:60%;">
  {#if time_modus == "monthly"}
    <table style="margin-top: 40px; width:90%; margin-left:5%; margin-right: 5%;">
      <tr>
        <th />
        <th />
        <th />
        <th />
      </tr>
      <tr>
        <td
          ><div
            class="small-rect-2"
            style="background-color:{color_list[0]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
          /></td
        >
        <td>New LEADS</td>
        {#if year != new Date().getFullYear()}
          <td><b>{percentage_math(dict_to_sum(leads_month_data), target_lead).toFixed(0)}%</b></td>
        {:else}
          <td><b>{percentage_math(dict_to_sum(leads_month_data), current_target_lead).toFixed(0)}%</b></td>
        {/if}

        <td nowrap style="text-align:right;"
          >{replace_dot(nFormatter_org(dict_to_sum(leads_month_data)))}
          {#if include_vorjahr}
            <div style="color: #d2d2d2; display: inline-block;">
              [PY: {replace_dot(nFormatter_org(dict_to_sum(leads_month_data_last_year)))}]
            </div>
          {/if}
          <div style="display: inline-block;">|</div>

          {#if year != new Date().getFullYear()}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(target_lead))}</div>
          {:else}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(current_target_lead))}</div>
          {/if}
        </td>
      </tr>
      <tr>
        <td
          ><div
            class="small-rect-2"
            style="background-color:{color_list[1]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
          /></td
        >
        <td>New OPP</td>

        {#if year != new Date().getFullYear()}
          <td><b>{percentage_math(dict_to_sum(opp_month_data), target_opp).toFixed(0)}%</b></td>
        {:else}
          <td><b>{percentage_math(dict_to_sum(opp_month_data), current_target_opp).toFixed(0)}%</b></td>
        {/if}

        <td nowrap style="text-align:right;"
          >{replace_dot(nFormatter_org(dict_to_sum(opp_month_data)))}
          {#if include_vorjahr}
            <div style="color: #d2d2d2; display: inline-block;">
              [PY: {replace_dot(nFormatter_org(dict_to_sum(opp_month_data_last_year)))}]
            </div>
          {/if}
          <div style="display: inline-block;">|</div>

          {#if year != new Date().getFullYear()}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(target_opp))}</div>
          {:else}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(current_target_opp))}</div>
          {/if}
        </td>
      </tr>
      <tr>
        <td
          ><div
            class="small-rect-2"
            style="background-color:{color_list[2]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
          /></td
        >
        <td>New CUST</td>

        {#if year != new Date().getFullYear()}
          <td><b>{percentage_math(dict_to_sum(cust_month_data), target_cust).toFixed(0)}%</b></td>
        {:else}
          <td><b>{percentage_math(dict_to_sum(cust_month_data), current_target_cust).toFixed(0)}%</b></td>
        {/if}

        <td nowrap style="text-align:right;"
          >{replace_dot(nFormatter_org(dict_to_sum(cust_month_data)))}
          {#if include_vorjahr}
            <div style="color: #d2d2d2; display: inline-block;">
              [PY: {replace_dot(nFormatter_org(dict_to_sum(cust_month_data_last_year)))}]
            </div>
          {/if}
          <div style="display: inline-block;">|</div>

          {#if year != new Date().getFullYear()}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(target_cust, 0))}</div>
          {:else}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(current_target_cust, 0))}</div>
          {/if}
        </td>
      </tr>
      <tr>
        <td
          ><div
            class="small-rect-2"
            style="background-color:{color_list[3]}; margin-top: auto; margin-bottom: auto; margin-right: 6px;"
          /></td
        >
        <td>Sold BOLUSES</td>

        {#if year != new Date().getFullYear()}
          <td><b>{percentage_math(dict_to_sum(boli_month_data), target_boli).toFixed(0)}%</b></td>
        {:else}
          <td><b>{percentage_math(dict_to_sum(boli_month_data), current_target_boli).toFixed(0)}%</b></td>
        {/if}

        <td nowrap style="text-align:right;"
          >{replace_dot(nFormatter_org(dict_to_sum(boli_month_data)))}
          {#if include_vorjahr}
            <div style="color: #d2d2d2; display: inline-block;">
              [PY: {replace_dot(nFormatter_org(dict_to_sum(boli_month_data_last_year)))}]
            </div>
          {/if}
          <div style="display: inline-block;">|</div>

          {#if year != new Date().getFullYear()}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(target_boli))}</div>
          {:else}
            <div style="color: #4eb3cf; display: inline-block;">{replace_dot(nFormatter_org(current_target_boli))}</div>
          {/if}
        </td>
      </tr>
    </table>
  {/if}

  {#if time_modus == "quaterly" || time_modus == "biannual"}
    <div class="col-12" style="margin:0px; padding:0px; height:{chart_hoehe_2}px;">
      <LineBarMixedChartTwoYAxis
        id={Math.floor(Math.random() * 1000000)}
        line_data={data}
        barPercentage={0.9}
        categoryPercentage={0.7}
        type={"bar"}
        bind:redraw
        k={true}
        tausender_trennzeichen={true}
      />
    </div>
  {/if}
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }

  .small-rect-2 {
    width: 10px;
    height: 10px;
    border: 1px solid transparent;
    padding: 0px;
  }

  .dot-innen-gruen {
    height: 15px;
    width: 15px;
    background-color: #c1e010;
    border-radius: 50%;
    padding: 0px;
    display: inline-block;
    margin-left: auto;
    margin-bottom: auto;
    margin-top: auto;
  }

  .dot-innen-orange {
    height: 15px;
    width: 15px;
    background-color: #ffc000;
    border-radius: 50%;
    padding: 0px;
    display: inline-block;
    margin-left: auto;
    margin-bottom: auto;
    margin-top: auto;
  }
</style>
